<template>
  <v-card class="rounded-lg pa-2 white  pb-8" flat>
    <v-card-title class="secondary--text">
      <v-img class="ml-2" src="/img/icons/docsChart.svg" max-width="25"></v-img>
      نمودار اسناد
      <v-spacer></v-spacer>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="/report/lists/sanads"
                 target="_blank">
            <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
          </v-btn>
        </template>
        مشاهده کامل اسناد
      </v-tooltip>

      <chart-export-btn page-chart-id="docs-chart"></chart-export-btn>
    </v-card-title>
    <div
        class="secondary--text text-h5"
        style="width: 100%; height: 40px; position: absolute; top: 50%; left: 0; margin-top: auto; line-height:19px; text-align: center; z-index: 999999999999999">
       تعداد اسناد
      <v-spacer></v-spacer>
      <br/>
      <span v-if="chartResult" class="grey--text text-h6"> جمع کل : {{chartResult.sum}} سند</span>


    </div>
    <canvas id="docs-chart">

    </canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'documentsChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartResult: null,
      chartData: {
        type: "doughnut",
        data: {
          labels: ["اسناد قطعی", "اسناد غیر قطعی", "اسناد خالی", "اسناد نامتوازن"],
          datasets: [
            {
              data: [],
              backgroundColor: ["#50CC89", "#FFC700", "#43CED7", "#F1416C"],
              borderWidth: 3,
              hoverBorderWidth: 5,
              hoverBorderColor: '#FFFFFF',
            },
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          legend: {
            position: 'bottom'
          },
          cutoutPercentage: 70,
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
            },
          }
        }
      }
    }
  },
  mounted() {
    this.getChartFromApi()

  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/sanadsChartReport`),
        method: "get",
        success: data => {
          this.chartResult = data
          this.getData(data)
        }
      })
    },

    getData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  this.titleSize

      this.chartData.data.datasets[0].data = []
      this.chartData.data.datasets[0].data.push(data['defined'])
      this.chartData.data.datasets[0].data.push(data['undefined'])
      this.chartData.data.datasets[0].data.push(data['empty'])
      this.chartData.data.datasets[0].data.push(data['unbalanced'])

      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('docs-chart');
      new Chart(ctx, this.chartData);
    }

  },
  computed: {
    titleSize() {
      if (this.main) {
        return 18
      } else {
        return 13
      }
    },
  },

}
</script>